import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useMutation, UseMutationResult } from '@tanstack/react-query';

export function useUploadAttachment(): UseMutationResult<
  undefined,
  ExtendedAxiosError,
  { url: string; attachment: File }
> {
  return useMutation<
    undefined,
    ExtendedAxiosError,
    { url: string; attachment: File }
  >({
    mutationKey: ['highbond-drive', 'upload'],
    meta: {
      handleError: true,
    },
    mutationFn: async ({ url, attachment }) => {
      const urlObj = new URL(url);
      const domain = urlObj.hostname;
      const tld = domain.split('.').pop();

      if (tld === 'test') {
        const fakeUpload = new Promise<undefined>((resolve) => {
          setTimeout(() => {
            resolve(undefined);
          }, 1000);
        });
        return fakeUpload;
      }

      // Use native fetch instead of axios to avoid interceptor issues with S3
      const response = await fetch(url, {
        method: 'PUT',
        body: attachment,
        headers: {
          'Content-Type': attachment.type,
        },
      });

      if (!response.ok) {
        // Convert fetch error to axios-like error format
        const responseData = await response.text();
        const error: ExtendedAxiosError = {
          name: 'AxiosError',
          message: `Request failed with status code ${response.status}`,
          config: {} as never,
          code: response.status.toString(),
          request: {},
          response: {
            data: responseData as never, // S3 returns XML string, not ResponseErrorData
            status: response.status,
            statusText: response.statusText,
            headers: {} as never,
            config: {} as never,
          },
          isAxiosError: true,
          toJSON: () => ({}),
        };
        throw error;
      }

      return undefined;
    },
  });
}
